import React from "react";
import { Product } from "../types/product";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { getGoogleDriveId } from "../utils/generalFunction";

interface ProductCardProps {
  product: Product;
  onClick?: () => void;
}

const ProductCard: React.FC<ProductCardProps> = (props) => {
  var InverterLabel = () => {
    if (props.product?.name?.toLocaleLowerCase().includes("inverter")) {
      return (
        <Box
          className="!text-xs font-medium"
          sx={{
            backgroundColor: "#e0f7fa",
            color: "#00796b",
            display: "inline-block",
            px: 1,
            borderRadius: 1,
            mt: 1,
          }}
        >
          INVERTER
        </Box>
      );
    } else {
      return <></>;
    }
  };
  return (
    <Card
      onClick={props.onClick}
      className="relative rounded-md hover:shadow-xl transition-shadow duration-300"
    >
      <Typography
        variant="caption"
        sx={{ color: "#888" }}
        className="absolute top-2 left-2 text-sm"
      >
        {props.product.brandName}
      </Typography>
      <CardMedia
        component="img"
        image={`https://images.weserv.nl/?url=https://drive.google.com/uc?id=${getGoogleDriveId(
          props.product.productImage?.[0] ?? ""
        )}`}
        alt={props.product.name}
        // sx={{ objectFit: "contain", p: 2, height: 180 }}
      />

      {/* <IconButton
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          backgroundColor: "white",
        }}
      >
        <FavoriteBorderIcon />
      </IconButton> */}
      <CardContent>
        <Typography className="!text-sm !font-medium">
          {props.product.name}
        </Typography>
        <InverterLabel></InverterLabel>
        {props.product.regularDiscount !== 0 && (
          <Box className="flex items-center gap-2">
            <Typography className="!text-[12px] line-through pt-1 pb-0">
              {props.product.regularPrice?.toLocaleString("vi-VN")}
              <sup>₫</sup>
            </Typography>
            {props.product.regularDiscount && props.product.regularPrice && (
              <Typography className="!text-[12px] pt-1 pb-0 text-red-500 !font-semibold">
                (-
                {Math.ceil(
                  ((props.product.regularPrice -
                    props.product.regularDiscount) /
                    props.product.regularPrice) *
                    100
                )?.toLocaleString("vi-VN")}
                %)
              </Typography>
            )}
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography className="!text-sm !font-medium pt-1 text-primary_blue">
            {props.product.regularPrice === 0 ? (
              <span>liên hệ</span>
            ) : (props.product?.regularDiscount ?? 0) > 0 ? (
              props.product.regularDiscount?.toLocaleString()
            ) : (
              props.product.regularPrice?.toLocaleString()
            )}
            {props.product.regularPrice === 0 ? <></> : <sup>đ</sup>}
          </Typography>

          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "#36B864",
              borderRadius: 2,
              // Responsive styles
              minWidth: { xs: "auto", sm: "auto" }, // Prevent button from being too wide on mobile
              padding: { xs: "6px", sm: "6px 16px" }, // Smaller padding on mobile
              fontSize: { xs: 0, sm: "0.875rem" }, // Hide text on mobile by setting fontSize to 0
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& .MuiButton-startIcon": {
                margin: { xs: 0, sm: "0 8px 0 0" }, // Adjust icon margin
              },
            }}
            startIcon={<AddShoppingCartIcon />}
          ></Button> */}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
